import { render } from "./languageSelector.vue?vue&type=template&id=24d24634&scoped=true"
import script from "./languageSelector.vue?vue&type=script&lang=js"
export * from "./languageSelector.vue?vue&type=script&lang=js"

import "./languageSelector.vue?vue&type=style&index=0&id=24d24634&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d24634"]])

export default __exports__